import React from 'react';
import PropTypes from 'prop-types';

const AgreementBox = (props) => {
  const { content, id } = props;

  return (
    <div className="agreementBox" id={id}>
      <span dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

AgreementBox.propTypes = {
  content: PropTypes.string,
  id: PropTypes.string,
};

export default React.memo(AgreementBox);
